// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T18:28:35.367Z
// Property: Finley West (ID: 6767906449162887)
// Collections: 40 amenities, 13 floorplans (live), 47 photos, 4 POIs, 2 reviews, 5 virtual tours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449162887",
  "property_external_id": "4600725",
  "property_zillow_url": "https://www.zillow.com/b/9940-richmond-ave-houston-tx-5XkBgp/",
  "property_apartments_url": "https://www.apartments.com/finley-west-houston-tx/1vebd17",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "finley-west",
  "property_name": "Finley West",
  "property_website_url": "https://www.finleywest.com/",
  "property_domain": null,
  "property_address": "9940 Richmond Ave",
  "property_full_address": "9940 Richmond Ave",
  "property_address_1": "9940 Richmond Ave",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": "77042-4560",
  "property_address_zip": "77042",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Westchase",
  "property_address_latitude": "29.7300783",
  "property_address_longitude": "-95.546923",
  "property_email": "finley@alapts.com",
  "property_phone": "(713) 780-4617",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Finley West in Houston, Texas! Discover our thoughtfully designed one and two-bedroom floor plans, complete with modern amenities like a refreshing pool, convenient laundry facilities, and 24-hour access. Find your new home today—browse our availability or schedule a tour to explore our vibrant community!",
  "property_long_description": "**Welcome to Finley West: Your Ideal Houston Apartment Community!**\n\nDiscover the perfect blend of comfort and convenience at Finley West, located in the heart of Houston, Texas. Our thoughtfully designed apartment community offers a variety of floor plans, including spacious one-bedroom and two-bedroom options, tailored to meet your lifestyle needs. Whether you're a busy professional or starting a family, Finley West has the space you need to thrive. \n\nOur amenities are crafted for your convenience and leisure. Dive into relaxation at our shimmering pool, perfect for those warm Texas afternoons. For added ease, residents have access to on-site laundry facilities, making chores a breeze. With 24-hour access to the community, you can enjoy your residence on your own terms, day or night. Each apartment features a private bathroom, ensuring you have your own sanctuary to unwind after a long day. Our charming walk-up units provide a unique touch of accessibility and character.\n\nAt Finley West, you’re not just renting an apartment; you’re joining a community that prioritizes your comfort and satisfaction. Explore all that our inviting environment has to offer, from modern amenities to a friendly neighborhood vibe. \n\nFind your new home today! Browse our availability or schedule a tour to visit our community and experience the Finley West lifestyle for yourself. We can’t wait to welcome you home!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-9ed7-75f0-9766-bf7c20fc07fe.webp",
  "property_featured_image_media": {
    "alt_text": "Modern living room and dining area with a kitchen bar.",
    "public_id": "019cfddc-9ed7-75f0-9766-bf7c20fc07fe",
    "storage_key": "property/6767906449162887/019cfddc-9ed7-75f0-9766-bf7c20fc07fe.webp",
    "width": 1240,
    "height": 826
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "224",
  "property_year_built": "1980",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.66071428571429",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": null,
  "property_allows_cats": null,
  "property_allows_dogs": null,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": null,
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": null,
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-92de-75bb-acce-ae18f60d00c3.webp",
  "property_primary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddc-92de-75bb-acce-ae18f60d00c3",
    "storage_key": "property/6767906449162887/019cfddc-92de-75bb-acce-ae18f60d00c3.webp",
    "width": 325,
    "height": 147
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-92de-75bb-acce-ae18f60d00c3.webp",
  "property_secondary_logo_media": {
    "alt_text": "American Landmark logo",
    "public_id": "019cfddc-92de-75bb-acce-ae18f60d00c3",
    "storage_key": "property/6767906449162887/019cfddc-92de-75bb-acce-ae18f60d00c3.webp",
    "width": 325,
    "height": 147
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2713-d4f5-701a-91f4-9c4e82dc6c6b",
    "storage_key": "company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Repli logo",
    "public_id": "019d2705-ea93-721c-8d4f-e2d2a439a839",
    "storage_key": "company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
    "width": 640,
    "height": 314
  },
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "733 - 1262",
  "property_sqft_min": "733",
  "property_sqft_max": "1262",
  "property_price_range": "954.5 - 1534.33",
  "property_price_min": "954.5",
  "property_price_max": "1534.33",
  "property_available_units": 3,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": null,
  "property_home_romance_title": null,
  "property_home_amenities_blurb": null,
  "property_home_floorplans_blurb": null,
  "property_home_gallery_blurb": null,
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Finley West in Houston, Texas. Choose from our spacious one- and two-bedroom floor plans, perfectly designed for modern living. Explore local favorites, unique attractions, and nearby points of interest. See what's around our community and make Finley West your ideal home today!",
  "property_home_reviews_blurb": null,
  "property_neighborhood_blurb": "Westchase is largely known as a business district, and many of the local residents are corporate professionals seeking to avoid the long, traffic-laden commutes that Houston is known for. The community is home to numerous office buildings, with a popular shopping area along Westheimer Road and several medical centers and schools in the mix as well. The rental market includes a variety of property styles, from swanky country club homes to modest efficiency apartments, catering to the needs of the diverse local workforce.\n\t\t\t\t\tGolf courses and large public parks around Westchase are popular among locals seeking time outdoors, particularly the trails around Arthur Storey Park. Houston’s Chinatown is nearby, and Asian cultural influences contribute to a unique environment. Downtown Houston is only a short drive to the east, and the sprawling George Bush Park is just a quick hop away as well.\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\tLearn more about living in Westchase",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Finley West in Houston, Texas! Discover our spacious one and two-bedroom floor plans, complete with private bathrooms and convenient laundry facilities. Take a refreshing dip in our inviting pool and enjoy 24-hour access for ultimate comfort. Explore our amazing community amenities and apartment features today!",
  "property_applynow_blurb": "Explore Finley West in Houston, Texas, where comfort meets convenience. Choose from our spacious one and two-bedroom floor plans, complete with modern amenities like a refreshing pool, laundry facilities, and private bathrooms. Apply now and find your new home—lease online today for 24-hour access to your perfect apartment!",
  "property_contactus_blurb": "Discover your perfect home at Finley West in Houston, Texas! Our inviting community offers thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Have questions? Contact our leasing team today to learn more or schedule a visit! Your dream apartment awaits at Finley West!",
  "property_faqs_blurb": "Discover the perfect home at Finley West in Houston, Texas, with a variety of floor plans, including spacious one-bedroom and two-bedroom options. Have questions? Browse our FAQs page for answers about our vibrant community and make the best choice for your lifestyle at Finley West!",
  "property_floorplans_blurb": "Discover your ideal living space at Finley West in Houston, Texas! Our carefully designed floor plans include stylish one-bedroom and spacious two-bedroom options to suit your lifestyle. Browse our available apartment homes today and find the perfect floor plan that fits your needs! Your dream home awaits!",
  "property_gallery_blurb": "Discover your ideal home at Finley West in Houston, Texas! Choose from spacious one and two-bedroom floor plans, each featuring private bathrooms and convenient walk-up access. Enjoy amenities like a refreshing pool and 24-hour laundry facilities. Picture yourself living here—explore our photo gallery today!",
  "property_interactivemap_blurb": "Discover your ideal home at Finley West in Houston, Texas! With spacious one and two-bedroom floor plans, private bathrooms, and 24-hour access, our community offers unparalleled amenities including a refreshing pool and convenient laundry facilities. Use our interactive community map to explore available apartments and find your perfect fit today!",
  "property_pets_blurb": null,
  "property_referafriend_blurb": "Discover your ideal living space at Finley West in Houston, Texas! With versatile floor plans, including one and two-bedroom apartments, you’ll find the perfect home. Great friends make great neighbors—refer a friend to our vibrant community today and enjoy exclusive benefits together! Explore all our options now!",
  "property_residentaccess_blurb": "Welcome to Finley West in Houston, Texas! Explore our spacious one and two-bedroom floor plans tailored for your lifestyle. Current residents can easily manage their living experience—access the resident portal today to pay rent, schedule maintenance, and more! Your comfortable home awaits!",
  "property_reviews_blurb": null,
  "property_created_at": "1752257798553",
  "property_scheduletour_blurb": "Discover your perfect home at Finley West in Houston, Texas! Our thoughtfully designed one and two bedroom floor plans cater to your lifestyle. Schedule a tour today and explore what makes our community special. Don’t forget to check out what our residents have to say about living here!",
  "property_thankyou_blurb": "Thank you for your submission! At Finley West in Houston, Texas, we offer a variety of spacious floor plans, including one and two-bedroom options to suit your lifestyle. Explore our community's modern amenities and vibrant surroundings. A member of our team will contact you shortly to assist you further!",
  "property_virtualtours_blurb": "Discover your ideal home at Finley West in Houston, Texas! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Explore our vibrant community and see all that Finley West has to offer. Take a virtual tour of our apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Finley West",
  "property_seo_title_home": "Finley West | Apartments in Houston, Texas",
  "property_seo_description_home": "Discover your perfect oasis at Finley West in Houston, Texas! Explore our spacious one and two-bedroom floor plans, designed for comfort and convenience. Enjoy top-notch amenities, including a refreshing pool, on-site laundry, and 24-hour access to your private sanctuary. With walk-up options and private bathrooms, you'll find everything you need right here. Find your new home today at Finley West!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Houston, Texas",
  "property_seo_description_floorplans": "Explore Finley West in Houston, Texas, and discover the perfect apartment for your lifestyle! Whether you're looking for a cozy one-bedroom or a spacious two-bedroom, our diverse floor plans cater to all needs. Browse our available apartment homes today and find your ideal living space at Finley West!",
  "property_seo_title_amenities": "Amenities | Houston, Texas Apartments for Rent",
  "property_seo_description_amenities": "Discover exceptional living at Finley West in Houston, Texas! Explore our variety of floor plans, including spacious one and two-bedroom apartments, each featuring private bathrooms and convenient walk-up access. Enjoy resort-style amenities such as a refreshing pool and 24-hour laundry facilities. Dive into a vibrant community that caters to your lifestyle. Don’t miss out—explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, Texas",
  "property_seo_description_gallery": "\"Explore the vibrant photo gallery of Finley West, your ideal apartment community in Houston, Texas! Discover spacious one and two-bedroom floor plans featuring private bathrooms and convenient laundry facilities. Dive into resort-style living with our refreshing pool and enjoy 24-hour access for your comfort. Picture yourself living here—view all our stunning images today!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Finley West Apartments",
  "property_seo_description_virtualtours": "Discover your new home at Finley West in Houston, Texas! Explore our spacious one and two-bedroom floor plans and experience the comfort of modern living. Take a virtual tour of our vibrant community and see why our apartments for rent are the perfect fit for you. Don't miss out—take your virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Finley West Apartments",
  "property_seo_description_interactivemap": "Explore Finley West in Houston, Texas—your ideal apartment community featuring spacious one and two-bedroom floor plans. Enjoy top-notch amenities including a refreshing pool, convenient laundry facilities, and 24-hour access to your new home, complete with private bathrooms and walk-up entries. Use our interactive community map to easily find available apartments, view pricing, and start your journey to a new living space today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, Texas",
  "property_seo_description_neighborhood": "Discover the vibrant neighborhood surrounding Finley West in Houston, Texas! Explore our community and uncover local favorites, restaurants, parks, and cultural attractions. Whether you're looking for a cozy one-bedroom or spacious two-bedroom apartment, experience the perfect blend of comfort and convenience. See what's around our community today!",
  "property_seo_title_contact": "Contact Us | Finley West",
  "property_seo_description_contact": "Discover your perfect home at Finley West in Houston, Texas! Explore our diverse floor plans featuring one-bedroom and two-bedroom options tailored to your lifestyle. Have questions? Contact our leasing team today for personalized assistance and start your journey to upscale living!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, Texas",
  "property_seo_description_faqs": "Discover the vibrant living experience at Finley West in Houston, Texas! Explore our diverse floor plans, from cozy one-bedroom to spacious two-bedroom apartments, complete with enticing amenities like a refreshing pool, convenient laundry facilities, 24-hour access, and private bathrooms. Have questions? Browse our FAQs page for answers about our community and make your move today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, Texas",
  "property_seo_description_reviews": "Discover why residents love calling Finley West home in Houston, Texas! Explore our one and two-bedroom floor plans, complemented by top-notch amenities like a refreshing pool, convenient laundry facilities, and 24-hour access. Each unit features a private bathroom for your comfort. Read our resident reviews and see what makes our community special – your perfect apartment awaits at Finley West!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, Texas",
  "property_seo_description_applynow": "Discover your perfect home at Finley West in Houston, Texas! Choose from spacious one and two-bedroom floor plans featuring private bathrooms and convenient walk-up access. Enjoy exceptional amenities including a refreshing pool and 24-hour laundry facilities. Don't wait—apply now to find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Finley West",
  "property_seo_description_residentaccess": "\"Welcome to Finley West in Houston, Texas! Access your resident portal easily to pay rent, schedule maintenance, and manage your living experience seamlessly. Log in now and enjoy convenient living at your fingertips!\"",
  "property_seo_title_referafriend": "Refer A Friend | Finley West",
  "property_seo_description_referafriend": "\"Discover the joy of community living at Finley West in Houston, Texas! Great friends make great neighbors—refer a friend to our vibrant apartment community today and enjoy exclusive rewards. Join us in creating unforgettable moments in your new home!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Finley West",
  "property_seo_description_scheduletour": "Discover your new home at Finley West in Houston, Texas! Experience modern living with top-notch amenities and vibrant community spaces. Schedule a tour of our welcoming apartment community today and see why Finley West is the perfect place for you!",
  "property_seo_title_privacy": "Privacy Policy | Finley West",
  "property_seo_description_privacy": "\"Discover how Finley West in Houston, Texas safeguards your privacy. Our comprehensive privacy policy outlines our commitment to protecting your personal information. Learn more about our practices and how we ensure your data security. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | Finley West",
  "property_seo_description_accessibility": "\"Discover Finley West in Houston, Texas—where we prioritize digital inclusion for all. Explore our comprehensive Accessibility Statement to learn how we strive to create an inclusive and welcoming community for everyone. Join us in embracing a barrier-free lifestyle!\"",
  "property_seo_title_sitemap": "Sitemap | Finley West",
  "property_seo_description_sitemap": "Explore the Finley West community in Houston, Texas! Discover our sitemap to easily navigate through our range of elegant apartments and amenities. Whether you're searching for your next home or just curious, view our sitemap to start your journey with us today!",
  "property_seo_title_thankyou": "Thank You | Finley West",
  "property_seo_description_thankyou": "Thank you for your interest in Finley West, Houston's premier apartment community! A member of our team will reach out shortly to assist you in finding your perfect home. Stay tuned for exciting updates and offers!",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1781121741454",
  "amenities": [
    {
      "id": "ec_1511ead2d3dfd7d3c47e0211",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Package Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89159bde7c7994eb627946ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae6891816b8b94267b2ca6c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecac05a1c8965a86b3790bc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "24-Hour Resident Package System",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_14dd5f434e459aba72e93e9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_643a31cde67af19c5c4ed661",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Alief School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2c17099e87e1b65982032ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "American Landmark 360 Resident Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9170a4a1b011e87979d6ca9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Convenient 24/7 Online Resident Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e58ad195cba9036f6c385ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Covered Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70e0a2113b9e98ea1fbf5a84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Designer Finished Countertops",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3f80dc4272761ed217971aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Double Basin Kitchen Sinks with Disposal",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_82fa99ccce3577610324d949",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Full Size Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_63520c661eaeb58dc3345fe3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Onsite Resident Laundry Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_345856434925240a5677fb42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Oversized Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6be4b5d74be45d11c8b88704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry Closets",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be652d687b63046d7189f68b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Outside Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d078d7e729da042eef0f38fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Private Patios and Balconies",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4fb4dc061137b65e33185e4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Two Inch Blinds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d690d27f29a9d7491d5aa4e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Wall Outlets with USB Ports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3cac3e4865f59e485cc9452b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ab255a715ebe66b1927afcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Wood Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbe4850518134a92b81c0e00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4c44b280d2333d11a9fb7fdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ecdccf95d6ad5f5255e4dd46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75afc8e20451b1452bf33d49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4371d3722edca994bda8b339",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Washer/Dryer Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a7078d4911fe89095366a68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d07a348f7cb4d4f38907f4bb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7ed64491d0cee42bda2b2196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9262b37eec87ddeab2280ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93e13cbd0726474dd6f7c1e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27922485c22e0b0d4d6d15cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e3a17f3547b86e4958ab979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_21d544890251740faf3ed0d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a73a13fc4034ec5601a73442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b5adf759d1ce3432750bd2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39ab7d87b4a2095673b20e92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d79544c4e523afc1dcf45714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2f592f0f3e663302192b693",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dd5793815fe34db4c9cab23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "external_id": "false",
      "title": "Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_83c88e4970755dc07ce1b69c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4ccf-db24-72cd-a72b-6535beafc639.webp",
      "image_media": {
        "alt_text": "Living room, dining room, and kitchen area with modern furnishings and decor.",
        "public_id": "019d4ccf-db24-72cd-a72b-6535beafc639",
        "storage_key": "property/6767906449162887/019d4ccf-db24-72cd-a72b-6535beafc639.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable sofa, a dining table set for four, and a breakfast bar with bar stools, connecting to a well-equipped kitchen.",
      "link": "false",
      "alt_text": "Living room, dining room, and kitchen area with modern furnishings and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rB_PwzItiQWVlrOS67xXA5tXNIuJTqE1srTGXX2IXbQ/102/image.jpg"
    },
    {
      "id": "ec_57ba4969fba5a0db3cb27223",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4ccf-db24-72cd-a72b-6535beafc639.webp",
      "image_media": {
        "alt_text": "Living room, dining room, and kitchen area with modern furnishings and decor.",
        "public_id": "019d4ccf-db24-72cd-a72b-6535beafc639",
        "storage_key": "property/6767906449162887/019d4ccf-db24-72cd-a72b-6535beafc639.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable sofa, a dining table set for four, and a breakfast bar with bar stools, connecting to a well-equipped kitchen.",
      "link": "false",
      "alt_text": "Living room, dining room, and kitchen area with modern furnishings and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/rB_PwzItiQWVlrOS67xXA5tXNIuJTqE1srTGXX2IXbQ/102/image.jpg"
    },
    {
      "id": "ec_923d93b02aa75376a1ae58a3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-e188-7385-91cc-4577a0b34571.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with blue lounge chairs and umbrellas.",
        "public_id": "019cfddb-e188-7385-91cc-4577a0b34571",
        "storage_key": "property/6767906449162887/019cfddb-e188-7385-91cc-4577a0b34571.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and ample shade.",
      "link": "false",
      "alt_text": "Sparkling outdoor swimming pool with blue lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/AjmCr7CABffHZfu0_cncfQn4-_KIMZyNT2YwbfihC5A/110/image.jpg"
    },
    {
      "id": "ec_290e8587a786ecdb79449fe2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-e1c3-758f-8b6c-1e5d66d23b71.webp",
      "image_media": {
        "alt_text": "Living room with blue walls, sliding glass doors, a sofa, an armchair, and a coffee table.",
        "public_id": "019cfddb-e1c3-758f-8b6c-1e5d66d23b71",
        "storage_key": "property/6767906449162887/019cfddb-e1c3-758f-8b6c-1e5d66d23b71.webp",
        "width": 2048,
        "height": 1152
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable sofa and armchair, a stylish coffee table, and elegant wall art. Enjoy natural light and access to a private patio through sliding glass doors.",
      "link": "false",
      "alt_text": "Living room with blue walls, sliding glass doors, a sofa, an armchair, and a coffee table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EkgnMyKzgSaTkIi5N453KdpbJcScuXEZj8QnjSPUcyg/102/image.jpg"
    },
    {
      "id": "ec_c4167ec466e622a1ecc13bc6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-e2d0-762e-a56d-b11e5c13e2ac.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
        "public_id": "019cfddb-e2d0-762e-a56d-b11e5c13e2ac",
        "storage_key": "property/6767906449162887/019cfddb-e2d0-762e-a56d-b11e5c13e2ac.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring cardio machines, strength training equipment, and free weights. Exercise balls are also available for your workout needs.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/DJlmE4ahLEX03qzhfmDJBcA3nqOAdifUIrnOSK2BwOI/110/image.jpg"
    },
    {
      "id": "ec_1c48a3127f2cb03cf62a3d25",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-eaa5-741f-bd18-d14656470666.webp",
      "image_media": {
        "alt_text": "Open concept living room with fireplace, dining area, and kitchen bar with stools.",
        "public_id": "019cfddb-eaa5-741f-bd18-d14656470666",
        "storage_key": "property/6767906449162887/019cfddb-eaa5-741f-bd18-d14656470666.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept apartment, featuring a cozy fireplace, a dedicated dining area, and a convenient kitchen bar with seating.",
      "link": "false",
      "alt_text": "Open concept living room with fireplace, dining area, and kitchen bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_H_TmYf4kiVQII15KvZT_fXGY9iV9NtwqFkjnZ_thT8/102/image.jpg"
    },
    {
      "id": "ec_05e342302c6eb810b38c527a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-ee55-7607-adc0-74dbcd850ab8.webp",
      "image_media": {
        "alt_text": "Beautifully decorated bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019cfddb-ee55-7607-adc0-74dbcd850ab8",
        "storage_key": "property/6767906449162887/019cfddb-ee55-7607-adc0-74dbcd850ab8.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished bedroom featuring a comfortable king-size bed, a modern dresser, and a stylish nightstand with a lamp.",
      "link": "false",
      "alt_text": "Beautifully decorated bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/TpgW7n9XzCbJ9I78Tku0G8k1sZCUVT2SKog_A8whoLY/102/image.jpg"
    },
    {
      "id": "ec_6d821da3cdce2e5b33161fce",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-f18f-7159-a428-423d92f5bdb1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019cfddb-f18f-7159-a428-423d92f5bdb1",
        "storage_key": "property/6767906449162887/019cfddb-f18f-7159-a428-423d92f5bdb1.webp",
        "width": 2048,
        "height": 1392
      },
      "title": "Apartment",
      "description": "Discover this stylish apartment bathroom featuring a sleek vanity with a vessel sink, a modern toilet, and a bathtub with a chic marble-patterned shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/G-luZXBOOSbiwjhyqonGehjLppd9aG93DzqGeN99V3M/119/image.jpg"
    },
    {
      "id": "ec_477e0b7cd829738f494c3bda",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-f016-713f-8371-9dfd041df252.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, chairs, and a TV displaying the American Landmark logo.",
        "public_id": "019cfddb-f016-713f-8371-9dfd041df252",
        "storage_key": "property/6767906449162887/019cfddb-f016-713f-8371-9dfd041df252.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a cozy fireplace, comfortable seating, and modern decor. Perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with a fireplace, sofa, chairs, and a TV displaying the American Landmark logo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/L5oNI0dGKV0B7a1i-LFOE8_PGmzj1Hys-gR1Om3riIU/102/image.jpg"
    },
    {
      "id": "ec_c303e4c1060353bf5a105d87",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-f6a4-71dc-a1c3-3d15df381f7d.webp",
      "image_media": {
        "alt_text": "Dining area with a wooden table set for four, leading to a kitchen with stainless steel appliances.",
        "public_id": "019cfddb-f6a4-71dc-a1c3-3d15df381f7d",
        "storage_key": "property/6767906449162887/019cfddb-f6a4-71dc-a1c3-3d15df381f7d.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Enjoy meals in your elegant dining area, adjacent to a modern kitchen equipped with stainless steel appliances.",
      "link": "false",
      "alt_text": "Dining area with a wooden table set for four, leading to a kitchen with stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/BnPVmOzYw-pX6Ux5iQfZTjwfHccMr9z0aaYtYjIVbZQ/119/image.jpg"
    },
    {
      "id": "ec_ba42d8212ac03573bc48b93a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-fa3f-7625-885e-e12d85cfeb5a.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, open to kitchen with island and stools.",
        "public_id": "019cfddb-fa3f-7625-885e-e12d85cfeb5a",
        "storage_key": "property/6767906449162887/019cfddb-fa3f-7625-885e-e12d85cfeb5a.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Enjoy meals in the open dining area, which flows seamlessly into the kitchen. Perfect for entertaining or casual dining.",
      "link": "false",
      "alt_text": "Dining area with table and chairs, open to kitchen with island and stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EhM8wxjHG4bdRqU62HPJNweN7PGOv6HLYQAE7Na2oQw/102/image.jpg"
    },
    {
      "id": "ec_b4afac9a3a3dfc23f777bbe4",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-ff8a-723d-b11e-f9b2ec6915ac.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019cfddb-ff8a-723d-b11e-f9b2ec6915ac",
        "storage_key": "property/6767906449162887/019cfddb-ff8a-723d-b11e-f9b2ec6915ac.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring sleek granite countertops, stainless steel appliances, and rich wood cabinetry, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/U5ORK1ezVMiwDuAJ9vEZDsJUVlXN_Lq1ldQY6yqU_DI/119/image.jpg"
    },
    {
      "id": "ec_f5bc15287779a1bf41d3e3e6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-fe58-7369-b01c-bb5f8e1b2907.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, bedside tables, and a ceiling fan.",
        "public_id": "019cfddb-fe58-7369-b01c-bb5f8e1b2907",
        "storage_key": "property/6767906449162887/019cfddb-fe58-7369-b01c-bb5f8e1b2907.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed with decorative pillows, elegant bedside tables with lamps, and a ceiling fan for comfort. The room is well-lit with natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, bedside tables, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/o3AMPVcSE175WfIqHq1Byodh8lYiQCLAlgcEyt8g7ys/102/image.jpg"
    },
    {
      "id": "ec_7789b57196b7d960c83c8580",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-077d-72fa-8fab-55d777d9da66.webp",
      "image_media": {
        "alt_text": "Stacked washer and dryer in a closet with folding doors.",
        "public_id": "019cfddc-077d-72fa-8fab-55d777d9da66",
        "storage_key": "property/6767906449162887/019cfddc-077d-72fa-8fab-55d777d9da66.webp",
        "width": 2048,
        "height": 1368
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry care.",
      "link": "false",
      "alt_text": "Stacked washer and dryer in a closet with folding doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Ho1wPlfSmuO89qoLjZYzd4rM8eNm487ilZpVet4WP_k/119/image.jpg"
    },
    {
      "id": "ec_85a5b57c8e6353a50f7f038c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-076d-7253-b9f4-69a5074ec472.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019cfddc-076d-7253-b9f4-69a5074ec472",
        "storage_key": "property/6767906449162887/019cfddc-076d-7253-b9f4-69a5074ec472.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning swimming pool, complete with comfortable lounge chairs and ample shade from umbrellas. Perfect for a sunny afternoon escape.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yk9aftrlidGNYjqdOy0ov6H2btAPgNp4CQusxu3hBDU/102/image.jpg"
    },
    {
      "id": "ec_861323e0fad1c4577d3a2a27",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-0940-77cb-9631-2e4fad1b8b7d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a pantry.",
        "public_id": "019cfddc-0940-77cb-9631-2e4fad1b8b7d",
        "storage_key": "property/6767906449162887/019cfddc-0940-77cb-9631-2e4fad1b8b7d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, elegant granite countertops, and stainless steel appliances. Includes ample pantry storage for all your needs.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and a pantry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/EY2aFvvpZVf9peAi6RMEzAH4qzweyEVWClmlESWTwRY/119/image.jpg"
    },
    {
      "id": "ec_b198be9c0d0f9ae354b84dcb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-0d64-748c-a5eb-599135ca8c95.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, ellipticals, weight machines, yoga balls, and dumbbells.",
        "public_id": "019cfddc-0d64-748c-a5eb-599135ca8c95",
        "storage_key": "property/6767906449162887/019cfddc-0d64-748c-a5eb-599135ca8c95.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment, weight machines, free weights, and yoga balls for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center gym with treadmills, ellipticals, weight machines, yoga balls, and dumbbells.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/5NUzWmwkyOxbJ3W9XUN6xrDjKD-_iZHWX3MzxM9rxWk/102/image.jpg"
    },
    {
      "id": "ec_6be3728ee12e74d59d3a226a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-14b2-75fc-b676-e84c07f601f3.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dark grey accent wall with abstract art, ceiling fan, and large window.",
        "public_id": "019cfddc-14b2-75fc-b676-e84c07f601f3",
        "storage_key": "property/6767906449162887/019cfddc-14b2-75fc-b676-e84c07f601f3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a stylish dark grey accent wall with modern art, and a ceiling fan for your comfort. Large windows provide ample natural light.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, dark grey accent wall with abstract art, ceiling fan, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/8O-mFjtzvXA01J0VJsQTt-q8BnEZLIpEyhFcN9lCdz0/118/image.jpg"
    },
    {
      "id": "ec_5a52117b8d28c971f4630451",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-1471-72d8-a443-05efcbd514cd.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019cfddc-1471-72d8-a443-05efcbd514cd",
        "storage_key": "property/6767906449162887/019cfddc-1471-72d8-a443-05efcbd514cd.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/FxVNfj8KHpTrFsunS_UvzWmVlI9MPNQVMxEZqYECCec/102/image.jpg"
    },
    {
      "id": "ec_7f7da25fe9f08db0809374bb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-16a9-7610-bd74-9f8514e2973b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, mounted TV, and sofa.",
        "public_id": "019cfddc-16a9-7610-bd74-9f8514e2973b",
        "storage_key": "property/6767906449162887/019cfddc-16a9-7610-bd74-9f8514e2973b.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a mounted television, and comfortable seating, perfect for relaxation.",
      "link": "false",
      "alt_text": "Living room with fireplace, mounted TV, and sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6HMTkXVy6TBqz-V_nCebXVdv07-fEQr0eP4uncskOI0/117/image.jpg"
    },
    {
      "id": "ec_d1feb4cab676f6ed6578b68b",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-1788-7153-956f-33920371fdb8.webp",
      "image_media": {
        "alt_text": "Starbucks coffee station with a large clock and coffee maker.",
        "public_id": "019cfddc-1788-7153-956f-33920371fdb8",
        "storage_key": "property/6767906449162887/019cfddc-1788-7153-956f-33920371fdb8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy complimentary Starbucks coffee and fresh brews at our community coffee station.",
      "link": "false",
      "alt_text": "Starbucks coffee station with a large clock and coffee maker.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_cP7-P8jrehYfPj-eh5lvP2WPgTm8cwyWjOqGaam-CI/102/image.jpg"
    },
    {
      "id": "ec_8b5d1c9a153203b77b6e52c2",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-2263-73ef-bc42-b08e7847bc4a.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, adjacent to a breakfast bar and kitchen.",
        "public_id": "019cfddc-2263-73ef-bc42-b08e7847bc4a",
        "storage_key": "property/6767906449162887/019cfddc-2263-73ef-bc42-b08e7847bc4a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "The dining area features a stylish table set for a meal, with a breakfast bar and modern kitchen visible in the background.",
      "link": "false",
      "alt_text": "Dining area with table and chairs, adjacent to a breakfast bar and kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/E48L6UX-y5dHAVF0RMymuE_6MRjm7fP5iGVou_Lly0Q/117/image.jpg"
    },
    {
      "id": "ec_2bf2779bffb3d7bdceeb85ed",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-2394-77ec-97f8-c2b2d147d19f.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, stationary bikes, and weight machine overlooking the pool.",
        "public_id": "019cfddc-2394-77ec-97f8-c2b2d147d19f",
        "storage_key": "property/6767906449162887/019cfddc-2394-77ec-97f8-c2b2d147d19f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment and strength training machines. Enjoy a workout with a view of the resort-style pool.",
      "link": "false",
      "alt_text": "Gym with treadmills, elliptical, stationary bikes, and weight machine overlooking the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/qStJSirlCQZWeALKmYw43BuQ2X0sy0CPDtTO1A6g6pU/102/image.jpg"
    },
    {
      "id": "ec_dd53d2969f634ddc247ea1a5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-24ae-7390-9297-f3202c38d30b.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019cfddc-24ae-7390-9297-f3202c38d30b",
        "storage_key": "property/6767906449162887/019cfddc-24ae-7390-9297-f3202c38d30b.webp",
        "width": 2000,
        "height": 1335
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed with plush bedding, a modern dresser with a mirror, and a stylish nightstand. The room is enhanced by tasteful wall art and a ceiling fan.",
      "link": "false",
      "alt_text": "Modern bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/cxxxaawK4eOTTv4zeVZgEms8qVw4RkNERZw2z3VjLtA/117/image.jpg"
    },
    {
      "id": "ec_5b07534bf9175acc24934f8f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-23dd-75f8-bfea-679d61086bbd.webp",
      "image_media": {
        "alt_text": "Package lockers with Finley West branding outside apartment building.",
        "public_id": "019cfddc-23dd-75f8-bfea-679d61086bbd",
        "storage_key": "property/6767906449162887/019cfddc-23dd-75f8-bfea-679d61086bbd.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Modern package lockers available for residents, featuring secure access and the Finley West branding.",
      "link": "false",
      "alt_text": "Package lockers with Finley West branding outside apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/QR-fZIPF-qwJJhluWQTsoxBt_0LStEe0gR7WYPHHmI4/102/image.jpg"
    },
    {
      "id": "ec_d5d05f03666455819a7b9a61",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-3010-74ff-a5fc-f7ad45f8e5d6.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with bi-fold doors.",
        "public_id": "019cfddc-3010-74ff-a5fc-f7ad45f8e5d6",
        "storage_key": "property/6767906449162887/019cfddc-3010-74ff-a5fc-f7ad45f8e5d6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer, perfect for your busy lifestyle.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with bi-fold doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tmkIT8JehKOk1uptBzYRvFgMOmoRwUv8mHFntKeoTng/117/image.jpg"
    },
    {
      "id": "ec_aabfd708692d45db214ba9db",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-2e44-73c8-a4c2-c2b7030d889a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with brick and gray siding, featuring outdoor staircases and lush landscaping.",
        "public_id": "019cfddc-2e44-73c8-a4c2-c2b7030d889a",
        "storage_key": "property/6767906449162887/019cfddc-2e44-73c8-a4c2-c2b7030d889a.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Explore the beautiful exteriors of our apartment buildings, showcasing a blend of classic brick and modern gray siding, complemented by well-maintained landscaping and accessible outdoor staircases.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with brick and gray siding, featuring outdoor staircases and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/VloJuNkDlbJau6E0lwHidaqXbDio0-hfeW00MnO8QuE/102/image.jpg"
    },
    {
      "id": "ec_8d5ba337428269d1a215be94",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-2f7f-7752-9320-ca084109f2d5.webp",
      "image_media": {
        "alt_text": "Living room with blue walls, gray sofa, coffee table, and abstract art.",
        "public_id": "019cfddc-2f7f-7752-9320-ca084109f2d5",
        "storage_key": "property/6767906449162887/019cfddc-2f7f-7752-9320-ca084109f2d5.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a plush gray sofa, elegant coffee table, and captivating abstract artwork.",
      "link": "false",
      "alt_text": "Living room with blue walls, gray sofa, coffee table, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/G1qr1pjyIcjM4ubLhTVN4jJ9aZKbUF-IO0Avzwdn4-I/117/image.jpg"
    },
    {
      "id": "ec_3fdce34bc97da4cc3ad443e7",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-31b5-7307-a2f6-e3f59f14521c.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables at an apartment complex.",
        "public_id": "019cfddc-31b5-7307-a2f6-e3f59f14521c",
        "storage_key": "property/6767906449162887/019cfddc-31b5-7307-a2f6-e3f59f14521c.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded seating areas. Perfect for a sunny afternoon.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/tNehc5PW0vLncbljTETiPcaQAJv1u8_PbTPkp0HpfAs/102/image.jpg"
    },
    {
      "id": "ec_a17c3b52427ec134239950fd",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-3be0-7297-bcef-44a165e8ea81.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with a sink and mirror, shower with a patterned curtain, and a toilet. Inset view shows washer and dryer.",
        "public_id": "019cfddc-3be0-7297-bcef-44a165e8ea81",
        "storage_key": "property/6767906449162887/019cfddc-3be0-7297-bcef-44a165e8ea81.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "View the spacious bathroom, complete with a vanity, sink, and mirror. The adjacent shower and toilet offer convenience, and a washer and dryer are visible in the adjoining room.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with a sink and mirror, shower with a patterned curtain, and a toilet. Inset view shows washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZkZ-AzzEPDWyw6sIyaeIqu2MZG87YDcuu9AywNTJmUw/117/image.jpg"
    },
    {
      "id": "ec_b61c752347e03e29f564d90c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-3aa6-73bf-a257-ac27d3aa3cd8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and green lawn.",
        "public_id": "019cfddc-3aa6-73bf-a257-ac27d3aa3cd8",
        "storage_key": "property/6767906449162887/019cfddc-3aa6-73bf-a257-ac27d3aa3cd8.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Explore the welcoming exterior of our apartment community, featuring beautifully landscaped grounds and modern architecture.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with walkways and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/F-EHv24BtppMyi_C8WWrL9V5ew_GJ3h1lU2hvdMNjKs/102/image.jpg"
    },
    {
      "id": "ec_83ec2e3621f4e15455956325",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-3dd4-7015-aabb-d0c8fb1b1927.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, including a refrigerator and dishwasher.",
        "public_id": "019cfddc-3dd4-7015-aabb-d0c8fb1b1927",
        "storage_key": "property/6767906449162887/019cfddc-3dd4-7015-aabb-d0c8fb1b1927.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Explore the beautifully appointed kitchen featuring granite countertops, ample cabinet space, and modern stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops and stainless steel appliances, including a refrigerator and dishwasher.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/3P_dRUgxD5gdc2hw3SU9iiGmBv8RgtK05s36BajSSxE/117/image.jpg"
    },
    {
      "id": "ec_ecdad26ba98282c8f876b2d6",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-407f-70ad-ba93-b27481f2d03f.webp",
      "image_media": {
        "alt_text": "Spacious living room with a dark blue couch, accent chairs, coffee table, and artwork.",
        "public_id": "019cfddc-407f-70ad-ba93-b27481f2d03f",
        "storage_key": "property/6767906449162887/019cfddc-407f-70ad-ba93-b27481f2d03f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living room, featuring comfortable seating, stylish decor, and ample space for entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with a dark blue couch, accent chairs, coffee table, and artwork.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/KtqCA4RGZQgqtl0qjfOD9-Pq9p8vejnKD7hpNID6fOU/102/image.jpg"
    },
    {
      "id": "ec_87462dabc113134e5c62723f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-47eb-70a5-ac60-63a475d9ba7b.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, TV, and modern furnishings.",
        "public_id": "019cfddc-47eb-70a5-ac60-63a475d9ba7b",
        "storage_key": "property/6767906449162887/019cfddc-47eb-70a5-ac60-63a475d9ba7b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a flat-screen TV displaying the American Landmark logo, and stylish seating.",
      "link": "false",
      "alt_text": "Living room with a fireplace, TV, and modern furnishings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Qc5_fSO1S5r13GqL0oPY8YuhlWiAFbZZ-XEv-0jt2YI/119/image.jpg"
    },
    {
      "id": "ec_5bb26b6493f3b7e4e6ac066f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-363e-7118-83ec-d564a0a9357e.webp",
      "image_media": {
        "alt_text": "Aerial view of a large, uniquely shaped swimming pool surrounded by lounge chairs and umbrellas.",
        "public_id": "019d4cd0-363e-7118-83ec-d564a0a9357e",
        "storage_key": "property/6767906449162887/019d4cd0-363e-7118-83ec-d564a0a9357e.webp",
        "width": 2000,
        "height": 1499
      },
      "title": "Community",
      "description": "Experience resort-style living with our stunning outdoor swimming pool, perfect for relaxing and unwinding under the sun. Surrounded by lush landscaping and comfortable seating.",
      "link": "false",
      "alt_text": "Aerial view of a large, uniquely shaped swimming pool surrounded by lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/A34ze5UqoyjVxIEBYUuDczMhjTbQZE18YmiKo0AF1Rg/102/image.jpg"
    },
    {
      "id": "ec_23d33d39d329172ab51e1a31",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-4b3d-70d9-99f8-b9c9bc599371.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and shower with a marble-patterned curtain.",
        "public_id": "019cfddc-4b3d-70d9-99f8-b9c9bc599371",
        "storage_key": "property/6767906449162887/019cfddc-4b3d-70d9-99f8-b9c9bc599371.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this modern bathroom, featuring a sleek vanity, a comfortable toilet, and a pristine shower area.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, toilet, and shower with a marble-patterned curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/yCD5Sub02H2g92Ea8juUPmzwgpnScCy1MH_WodJAXBg/117/image.jpg"
    },
    {
      "id": "ec_878b727fe9fe18bb09f66e94",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-446a-73cc-8532-5ea3d1970406.webp",
      "image_media": {
        "alt_text": "Finley West Premier Apartments monument sign with landscaped grounds and apartment buildings in the background.",
        "public_id": "019d4cd0-446a-73cc-8532-5ea3d1970406",
        "storage_key": "property/6767906449162887/019d4cd0-446a-73cc-8532-5ea3d1970406.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Welcome to Finley West Premier Apartments, featuring beautiful landscaping and well-maintained apartment buildings.",
      "link": "false",
      "alt_text": "Finley West Premier Apartments monument sign with landscaped grounds and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/G33zyciYhpNXEiaVw4r6nAsC9PgHoFmsLkFZBx0HBh0/102/image.jpg"
    },
    {
      "id": "ec_a61a0727257e1b83b692504f",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-5421-72e8-b152-e0ef810f144e.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing center building with landscaping and signage.",
        "public_id": "019cfddc-5421-72e8-b152-e0ef810f144e",
        "storage_key": "property/6767906449162887/019cfddc-5421-72e8-b152-e0ef810f144e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to our leasing center, where our friendly team is ready to assist you with finding your perfect home.",
      "link": "false",
      "alt_text": "Exterior of the leasing center building with landscaping and signage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/_fC8NxJNcC_WU7QX10V1CytKxaFxBybMx1q_K67yV74/116/image.jpg"
    },
    {
      "id": "ec_9c9353be4e416be1e9f2ba9a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-4a31-72e7-94c8-b3ba30456136.webp",
      "image_media": {
        "alt_text": "Kitchenette with coffee station and sink",
        "public_id": "019d4cd0-4a31-72e7-94c8-b3ba30456136",
        "storage_key": "property/6767906449162887/019d4cd0-4a31-72e7-94c8-b3ba30456136.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy complimentary coffee and tea at our convenient kitchenette station, perfect for a quick pick-me-up.",
      "link": "false",
      "alt_text": "Kitchenette with coffee station and sink",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/Hnm5tenTUKJdWlyLgMWd3HelV5U_aOKy2xetmO0gRTg/102/image.jpg"
    },
    {
      "id": "ec_c92e834ebc0c2a765363eb37",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-59cb-74ab-8aa3-de92f1b1ac89.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with seating and a large umbrella.",
        "public_id": "019cfddc-59cb-74ab-8aa3-de92f1b1ac89",
        "storage_key": "property/6767906449162887/019cfddc-59cb-74ab-8aa3-de92f1b1ac89.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor patio area, complete with comfortable seating and a large umbrella for shade.",
      "link": "false",
      "alt_text": "Outdoor patio area with seating and a large umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UtRrWYgZIuGXIhOBV4MAYW46ubUX4mnWw4q1PBL0Ulg/119/image.jpg"
    },
    {
      "id": "ec_d57d66185589e788c1bea654",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-5f5b-74cf-8f12-0808b3a4dd4c.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with townhouses, carports, and surrounding trees, with office buildings in the background.",
        "public_id": "019d4cd0-5f5b-74cf-8f12-0808b3a4dd4c",
        "storage_key": "property/6767906449162887/019d4cd0-5f5b-74cf-8f12-0808b3a4dd4c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Experience comfortable living in this charming multifamily community, featuring a mix of townhomes and apartments. Enjoy convenient carports and lush green surroundings, all set against a backdrop of modern office buildings.",
      "link": "false",
      "alt_text": "Aerial view of a multifamily apartment complex with townhouses, carports, and surrounding trees, with office buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/P4dntdrAjxgXVo4KUxvjDKCgW90lt_EzlZH6tSNav88/102/image.jpg"
    },
    {
      "id": "ec_f45c3972e02f8a752381aefb",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-51a1-76f9-8b60-df037faaf3ea.webp",
      "image_media": {
        "alt_text": "Dining room with a table set for four, grey chairs, and city art on the wall.",
        "public_id": "019d4cd0-51a1-76f9-8b60-df037faaf3ea",
        "storage_key": "property/6767906449162887/019d4cd0-51a1-76f9-8b60-df037faaf3ea.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals in this charming dining area, perfect for intimate gatherings or family dinners. Features elegant seating and stylish decor.",
      "link": "false",
      "alt_text": "Dining room with a table set for four, grey chairs, and city art on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/s7fp-i1DjJe7lp8pakulQXXuiUfEEAGMl5Ayri836U4/104/image.jpg"
    },
    {
      "id": "ec_c36ec139e5409df6b2f05138",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-63d9-7188-b666-c132f32684f8.webp",
      "image_media": {
        "alt_text": "Modern living room with blue sofa, armchair, coffee table, fireplace, and sliding glass door.",
        "public_id": "019cfddc-63d9-7188-b666-c132f32684f8",
        "storage_key": "property/6767906449162887/019cfddc-63d9-7188-b666-c132f32684f8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living space, featuring a comfortable blue sofa, plush armchair, and elegant decor. Enjoy the natural light from the sliding glass door.",
      "link": "false",
      "alt_text": "Modern living room with blue sofa, armchair, coffee table, fireplace, and sliding glass door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/ZSbvEMBjefEAc2l1OCg7dI3LK7yPzKFzEs1bN-cyNCA/118/image.jpg"
    },
    {
      "id": "ec_01c7e5114d13398035c22c22",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-5dd6-74aa-a1cd-3d4a4e44f2a8.webp",
      "image_media": {
        "alt_text": "Modern bedroom with king-size bed, dresser, and ceiling fan.",
        "public_id": "019d4cd0-5dd6-74aa-a1cd-3d4a4e44f2a8",
        "storage_key": "property/6767906449162887/019d4cd0-5dd6-74aa-a1cd-3d4a4e44f2a8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and elegantly designed bedroom featuring a comfortable king-size bed, ample dresser storage, and a stylish ceiling fan for optimal comfort.",
      "link": "false",
      "alt_text": "Modern bedroom with king-size bed, dresser, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/r9SXO_j0MtbPtSHTm8khONBSNTW-nSYwLioQtvK46Ys/104/image.jpg"
    },
    {
      "id": "ec_53bd4e31b021ef37672aa984",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddc-67b1-71f4-acb0-56e2d7784609.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelves and hanging rod.",
        "public_id": "019cfddc-67b1-71f4-acb0-56e2d7784609",
        "storage_key": "property/6767906449162887/019cfddc-67b1-71f4-acb0-56e2d7784609.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring shelving and a hanging rod for ample storage.",
      "link": "false",
      "alt_text": "Walk-in closet with shelves and hanging rod.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/UdJdHNSttwUgjN80LrmprPC1XuP28FYMW5OpdGYpx7o/118/image.jpg"
    },
    {
      "id": "ec_9a539231c2551c884ee7fd8a",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-65a1-718e-a731-fc34a8a1af49.webp",
      "image_media": {
        "alt_text": "Modern bathroom vanity with sink, toilet, and bathtub with shower curtain.",
        "public_id": "019d4cd0-65a1-718e-a731-fc34a8a1af49",
        "storage_key": "property/6767906449162887/019d4cd0-65a1-718e-a731-fc34a8a1af49.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Refresh and relax in this modern bathroom, featuring a spacious vanity with sink, a clean toilet, and a bathtub with a stylish shower curtain.",
      "link": "false",
      "alt_text": "Modern bathroom vanity with sink, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/6KmxCxSZX0yNqkcByvy7uKxuAN4DVHtZtqYgfWffWyQ/104/image.jpg"
    },
    {
      "id": "ec_a6d80112dc67c556f92bcb17",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019d4cd0-6656-76de-bb55-9c5b99285d35.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge chairs at Finley West Premier Apartments.",
        "public_id": "019d4cd0-6656-76de-bb55-9c5b99285d35",
        "storage_key": "property/6767906449162887/019d4cd0-6656-76de-bb55-9c5b99285d35.webp",
        "width": 2048,
        "height": 341
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool at Finley West Premier Apartments, featuring comfortable lounge chairs and vibrant blue seating.",
      "link": "false",
      "alt_text": "Swimming pool and lounge chairs at Finley West Premier Apartments.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://images1.apartments.com/i2/R7x8eAqG1Dg23LdNfusaLntVYC_0dWWVjUDkrrPvmxc/102/image.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_82f11bdd92f1f9e95408ce25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "poi_name": "Sneed Elementary School",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_deb66d8ade74e87deef3a9fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "poi_name": "Texas Connections Academy at Houston",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_9e566448bd5f103265d770ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "poi_name": "Wesley Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_cefdf1289ab97212b5b232ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "poi_name": "Alexander-Smith Academy",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [],
  "reviews": [
    {
      "id": "ec_bd1d718fb743c0975fb605ac",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "rating": "4",
      "name": "false",
      "text": "Richmond Green Apartment is one of the best, affordable, abide-able abodes in the axes of Highway 6, Beltway 8 and Southwest Freeway. I have been living here with my family for over a year now. The premises are usually clean. The trash-cans are emptied regularly. The security is tight. When you have complaints about the toilet or the kitchen sink not flushing down properly, the service guys respond on time. The blinds are good to help you save on energy during the day, since once they are slid up, the entire living room comes alive, brightly. That is possible because the premises have free space for light to permeate - the apartments are not jam-packed together at all. Little children can come outside too, in the evenings, and find space for soccer games. The residents here are friendly and respectful. There is no noise pollution in this environment. Yet, Kroger is just a walk away. A university - American Intercontinental University - is just across the road. And reputable companies like Phillips 66, Oasis Energy, US Energy Savings, Schlumberger, Vaalco Energy Inc, Spark Energy, and so on, are all surrounding it. For the kids, there is a school - Sneed Elementary - right across the road, and Texas Children Pediatrics, right behind it. I think this is the most sensible, cheapest and yet neatest apartment in the area, and it will help one save towards having one's own home some day. This is the perfect place for someone who has a taste and some class, and who is just starting-up. You can catch a bus right across the apartment, and alight, right in front of it. Great restaurants are a walk away, on the Briarpark side, overlooking Westheimer. There you have Chilis Grill and Bar, Fornos of Italy, Republic (a Texas Grill), Masala Wok, Outback Steakhouse, Thai Cottage, La Madeleine, Starbucks,  Rio Ranch Steakhouse, Subway, and so on.",
      "date": "false",
      "title": "Richmond Green Apartment"
    },
    {
      "id": "ec_588afdb95960cb53baf15ccf",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "rating": "5",
      "name": "false",
      "text": "I have  been here three years with no major issues with apartment  nor staff.  Maintenance  fixes things in a timely  manner.",
      "date": "false",
      "title": "Pleasant  experience  so far"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_af0c251f8f24548be98875ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Finley West",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/0r8i9o?source=180"
    },
    {
      "id": "ec_018e1d87d22fd45fde3ddbe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-e188-7385-91cc-4577a0b34571.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Sparkling outdoor swimming pool with blue lounge chairs and umbrellas.",
        "public_id": "019cfddb-e188-7385-91cc-4577a0b34571",
        "storage_key": "property/6767906449162887/019cfddb-e188-7385-91cc-4577a0b34571.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AKqmix4U9tx"
    },
    {
      "id": "ec_463659300629b60b0acdfe85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-e1c3-758f-8b6c-1e5d66d23b71.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with blue walls, sliding glass doors, a sofa, an armchair, and a coffee table.",
        "public_id": "019cfddb-e1c3-758f-8b6c-1e5d66d23b71",
        "storage_key": "property/6767906449162887/019cfddb-e1c3-758f-8b6c-1e5d66d23b71.webp",
        "width": 2048,
        "height": 1152
      },
      "virtual_tour_title": "2 BR, 2 BA - 1012SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eTQyX2hiUc6"
    },
    {
      "id": "ec_7632d0abaaa2c5e39f6dc398",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-e2d0-762e-a56d-b11e5c13e2ac.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
        "public_id": "019cfddb-e2d0-762e-a56d-b11e5c13e2ac",
        "storage_key": "property/6767906449162887/019cfddb-e2d0-762e-a56d-b11e5c13e2ac.webp",
        "width": 2048,
        "height": 1365
      },
      "virtual_tour_title": "Strength and Cardio Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zwkhKqVAKNa"
    },
    {
      "id": "ec_4769624a3f2545d72ddd5ce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162887/019cfddb-eaa5-741f-bd18-d14656470666.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Open concept living room with fireplace, dining area, and kitchen bar with stools.",
        "public_id": "019cfddb-eaa5-741f-bd18-d14656470666",
        "storage_key": "property/6767906449162887/019cfddb-eaa5-741f-bd18-d14656470666.webp",
        "width": 2048,
        "height": 1365
      },
      "virtual_tour_title": "2BR, 2BA - 1,046SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7x54AWqeqbf"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019f1bd7-6adb-747a-b19d-418417e00b17",
      "lead_source": "LANDING_PAGE",
      "name": "Finley West Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449162887"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    }
  ],
  "custom_rollout_phase": "Phase 2"
};

export const generatedAt = '2026-10-05T18:28:35.367Z';
